import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  EDIT_AHU,
  GET_BLOCKS,
} from "../../Config/Config";
import Swal from "sweetalert2";
import { Select, Spin } from "antd";
const { Option } = Select;

const EditHostAsset = ({ formData = {} }) => {
  const [disableFields] = useState(false);
  const [formState, setFormState] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    if (blocks.length > 0 && formData?.Location) {
      const matchedBlock = blocks.find(
        (block) => block.BlockId === Number(formData.Location)
      );
      setFormState({
        Code: formData?.Code,
        ahu_description: formData?.Description || "",
        area_zone_served: matchedBlock?.BlockId || "",
        department: formData?.Department || "",
        manufacturer: formData?.Manufacturer || "",
        model_number: formData?.ModelNo || "",
        capacity_cfm: formData?.Capacity || "",
        number_of_filters: formData?.Sparescount || "",
        remarks: formData?.Remarks || "",
      });
    }
  }, [blocks, formData]);

  console.log(formState, "formstsate");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      const result = await response.json();
      if (result?.ResultData) {
        setBlocks(result.ResultData);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  // Function to send notification
  const sendNotification = async () => {
    const notificationPayload = {
      Title: "Edit AHU",
      Message: "Request raised by Supervisor",
      RoleID: 3,
    };
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/addNotificationsToRole`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(notificationPayload),
        }
      );
      const result = await response.json();
      if (result.Status) {
        console.log("Notification sent successfully:", notificationPayload);
      } else {
        console.warn("Notification API failed:", result);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const handleEdit = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    const oldValues = {
      id: formData?.ID,
      Code: formData?.Code,
      Description: formData?.Description,
      Location: Number(formData?.Location),
      Department: formData?.Department,
      Manufacturer: formData?.Manufacturer,
      ModelNo: formData?.ModelNo,
      Capacity: formData?.Capacity,
      Sparescount: formData?.Sparescount,
      Remarks: formData?.Remarks,
      Updatedby: user?.UserID,
    };

    const newValues = {
      id: formData.ID,
      Code: formState.Code,
      Description: formState.ahu_description,
      Location: Number(formState.area_zone_served),
      Department: formState.department,
      Manufacturer: formState.manufacturer,
      ModelNo: formState.model_number,
      Capacity: formState.capacity_cfm,
      Sparescount: formState.number_of_filters,
      Remarks: formState.remarks,
      Updatedby: user?.UserID,
    };

    const labelMap = {
      Code: "Code",
      Description: "Description",
      Location: "Location",
      Department: "Department",
      Manufacturer: "Manufacturer",
      ModelNo: "ModelNo",
      Capacity: "Capacity",
      Sparescount: "Sparescount",
      Remarks: "Remarks",
    };

    const changedKeys = Object.keys(labelMap).filter(
      (key) => newValues[key] !== oldValues[key]
    );

    const screenValues = changedKeys.map((key) => labelMap[key]).join(", ");
    const updateValues = changedKeys.join(", ");

    const auditPayload = {
      ScreenName: "update AHU",
      ApiName: "updateAHU",
      OldValues: oldValues,
      NewValues: newValues,
      UpdateValues: updateValues,
      ScreenValues: screenValues,
      CreatedBy: user?.UserID,
    };

    console.log(JSON.stringify(auditPayload), "Audit Payload being sent");

    try {
      setIsSubmitting(true);

      const response = await fetch(`${getApiBaseUrl()}${EDIT_AHU}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditPayload),
      });

      const data = await response.json();
      const result = data?.ResultData?.[0];
      let isSuccess = 0;

      if (response.ok && result?.Status !== "Failure") {
        isSuccess = 1;
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "AHU updated successfully!",
        });
        await sendNotification();
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text:
            result?.ResultMessage || "Failed to update data. Please try again.",
        });
      }

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: "Request to update AHU",
          Location: "updateAHU",
          IsSucces: isSuccess,
        }),
      });
    } catch (error) {
      console.error("Network error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to connect to the server. Please try again.",
      });

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: "Request to update AHU",
          Location: "updateAHU",
          IsSucces: 0,
        }),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightEditHostAsset {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditHostAsset {
            width: 55% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditHostAsset {
            width: 35% !important;
          }
        }
        @media (min-width: 1441px) {
          #offcanvasRightEditHostAsset {
            width: 30% !important;
          }
        }
      `}
      </style>
      {isSubmitting && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditHostAsset"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit AHU Machine</h4>
          <div className="d-flex align-items-center ms-auto">
            <button
              type="submit"
              className="btn btn-sm btn-outline-success me-2"
              title="Update"
              disabled={isSubmitting}
              onClick={handleEdit}
            >
              <i className="fa fa-check fs-4"></i>
            </button>

            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
        </div>

        <hr className="m-0" />
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">AHU Unique Code</label>
              <input
                type="text"
                name="Code"
                value={formState.Code}
                onChange={handleChange}
                placeholder="Enter AHU Code"
                className="form-control"
                disabled={disableFields}
                required
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">AHU Description</label>
              <input
                type="text"
                className="form-control"
                name="ahu_description"
                disabled={disableFields}
                value={formState.ahu_description}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Block</label>
              <Select
                showSearch
                name="area_zone_served"
                value={formState.area_zone_served} // this will now be BlockId
                onChange={(value) =>
                  handleChange({ target: { name: "area_zone_served", value } })
                }
                placeholder="Select AHU Block"
                className="w-100"
                disabled={disableFields}
                required
                size="large"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {blocks.map((block) => (
                  <Option key={block.BlockId} value={block.BlockId}>
                    {block.BlockName}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Department</label>
              <input
                type="text"
                name="department"
                className="form-control"
                disabled={disableFields}
                value={formState.department}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Manufacturer</label>
              <input
                type="text"
                name="manufacturer"
                className="form-control"
                disabled={disableFields}
                value={formState.manufacturer}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Model Number</label>
              <input
                type="text"
                name="model_number"
                className="form-control"
                disabled={disableFields}
                value={formState.model_number}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Capacity (CFM)</label>
              <input
                type="number"
                name="capacity_cfm"
                className="form-control"
                disabled={disableFields}
                value={formState.capacity_cfm}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Number of Filters</label>
              <input
                type="number"
                name="number_of_filters"
                className="form-control"
                disabled={disableFields}
                value={formState.number_of_filters}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Remarks</label>
              <textarea
                rows="2"
                name="remarks"
                className="form-control"
                disabled={disableFields}
                value={formState.remarks}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
EditHostAsset.propTypes = {
  formData: PropTypes.object,
};

export default EditHostAsset;